import type { EbookStudyRecord } from '@wx-weiqi/contracts';

export type EbookStudyGrade = 'CORRECT' | 'INCORRECT';

/** A selected result is a local draft until the teacher explicitly saves it. */
export function ebookStudyGradeCommand(record: EbookStudyRecord, selected: EbookStudyGrade | null) {
  if (!record.submitted || selected === null || selected === record.status) return null;
  return {
    action: 'GRADE' as const,
    attemptId: record.id,
    expectedVersion: record.stateVersion,
    status: selected,
    feedback: selected === 'CORRECT' ? '教师已批改：正确' : '教师已批改：请再思考',
  };
}
